// extracted by mini-css-extract-plugin
module.exports = {"menu":"Menu_menu__SXl44","content":"Menu_content__GwxDD"};